
import { Box, Flex } from "@chakra-ui/react";
import { Outlet } from "react-router-dom";

import SideBar from "../SideBar/SideBar";
import { useCustomTheme } from "../../contexts/CustomThemeContext";
import PublicFooter from "../Footer/PublicFooter";

const DashboardLayout = () => {
  const { theme } = useCustomTheme();
  const isDark = theme.name === "dark";

  const pageBg = theme.gradients?.pageBg || theme.background;
  const shellBg = theme.gradients?.shellBg || theme.surface;
  const contentBg = theme.surface;
  const borderColor = theme.border;
  const panelShadow = theme.shadowMd;
  const cardsBorderRadii = "8px";

  const responsivePageBg = {
    base: isDark ? pageBg : "#fff",
    md: pageBg,
  };

  return (
    <Box
      bg={responsivePageBg}
      minH="92vh"
      color={theme.text}
    >
      <Flex
        minH="92vh"
        p="0px"
        gap={{ base: 0, md: 8 }}
        align="stretch"
      >
        {/* Sidebar */}
        <Box
          display={{ base: "none", md: "block" }}
          width="240px"
          flexShrink={0}
          pl={{ md: 3 }}
          pt={{ md: 3 }}
        >
          <SideBar />
        </Box>

        {/* Content Area */}
        <Box
          flex="1"
          minW={0}
          display="flex"
          flexDirection="column"
          pt="30px"
          pr={{ base: 0, md: "20px" }}
          pb={{ base: "0", md: "20px" }}
        >
          {/* No independent scrollbar */}
          <Box
            flex="1"
            bg={shellBg}
            border={{
              base: "none",
              md: `1px solid ${borderColor}`,
            }}
            borderRadius={{
              base: cardsBorderRadii,
              sm: cardsBorderRadii,
            }}
            backdropFilter={
              isDark ? "blur(8px)" : undefined
            }
          >
            <Box
              bg={contentBg}
              borderRadius={{
                base: cardsBorderRadii,
                sm: cardsBorderRadii,
              }}
              minH="100%"
              boxShadow={{
                base: "none",
                md: panelShadow,
              }}
              display="flex"
              flexDirection="column"
            >
              {/* Existing pages */}
              <Box flex="1" minW={0}>
                <Outlet />
              </Box>

              {/* Existing reusable footer */}
              <PublicFooter
                variant="light"
                background={
                  isDark ? theme.surface : "#f7fbfc"
                }
              />
            </Box>
          </Box>
        </Box>
      </Flex>
    </Box>
  );
};

export default DashboardLayout;
